import { applyQueryTriggerModification, updateIgnoreQueryTrigger, } from './triggers-actions.js';
import { commerceTriggersReducer as triggers } from './triggers-slice.js';
/**
 * Loads the commerce triggers reducer and returns the available triggers action creators.
 *
 * @param engine - The headless commerce engine.
 * @returns An object holding the triggers actions.
 *
 * @group Actions
 * @category Triggers
 */
export function loadTriggersActions(engine) {
    engine.addReducers({ triggers });
    return {
        updateIgnoreQueryTrigger,
        applyQueryTriggerModification,
    };
}
